<div class="z-lab-grid">
  <div class="x-title" [innerHTML]="xTitleHtml()"></div>
  <div class="z-title" [innerHTML]="zTitleHtml"></div>

  <div class="x-body">
    <dojo-normal-distribution-chart class="chart" [style.--chart-height.px]="chartHeight()" [params]="xChartParams()" />
    <div class="sliders">
      <dojo-slider
        param="μ"
        [paramHtml]="muLabelHtml"
        [min]="0"
        [max]="200"
        [step]="1"
        [value]="mu()"
        [editable]="true"
        color="orange"
        variant="minimal"
        (valueChange)="onMuChange($event)"
      />
      <dojo-slider
        param="σ"
        [paramHtml]="sigmaLabelHtml"
        [min]="1"
        [max]="50"
        [step]="0.5"
        [value]="sigma()"
        [editable]="true"
        color="indigo"
        variant="minimal"
        (valueChange)="onSigmaChange($event)"
      />
      <dojo-slider
        param="x"
        [min]="sliderXMin()"
        [max]="sliderXMax()"
        [step]="0.5"
        [value]="x()"
        [editable]="true"
        color="neutral"
        variant="minimal"
        (valueChange)="onXChange($event)"
      />
    </div>
  </div>

  <div class="z-body">
    <dojo-normal-distribution-chart class="chart" [style.--chart-height.px]="chartHeight()" [params]="zChartParams()" />
  </div>

  <div class="formula">
    <div class="formula-row" [innerHTML]="zFormulaHtml()"></div>
    <div class="formula-row" [innerHTML]="probFormulaHtml()"></div>
  </div>
</div>
